import React, { useState, Suspense } from "react";
import { Container } from "react-bootstrap";
import Experience from "./Components/Experience";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import HeroBanner from "./Components/HeroBanner";
import Project from "./Components/Project";
import SectionHeader from "./Components/SectionHeader";
import Skills from "./Components/Skills";
import Testimonial from "./Components/Testimonial";
import NewAbout from "./Components/NewAbout";
// lazy-loaded components to reduce initial bundle size
const ChatbotMain = React.lazy(() => import("./Components/Chatbot"));
const NoticeModal = React.lazy(() => import("./Modals/NoticeModal"));

function App() {
  const [modalShow, setModalShow] = useState(true);

  return (
    <>
      <Suspense fallback={<div />}>
        <NoticeModal show={modalShow} onHide={() => setModalShow(false)} />
      </Suspense>

      <div className="pt-4">
        <Header />
        <HeroBanner />
        {/* <div className="bg-color">
        <Container>
           <SectionHeader id='About' title='About Me' detail='Check out my professional experience below.' /> 
          <About />
        </Container>
      </div> */}
        <div className="about-main green-bg py-5">
          <Container>
            <SectionHeader
              id="About"
              title="About Me"
              detail={
                <>
                  <div>
                    Hey, I'm <b>Prakash Parmar</b>, a dedicated <b>Frontend Engineer</b> specializing in building responsive, high-performance web applications with exceptional user experiences. I excel in creating <b>Single Page Applications (SPA) and Progressive Web Apps (PWA)</b> using modern frontend technologies. My expertise includes <b>React.js, Next.js, Redux Toolkit, JavaScript (ES6+), TypeScript, Tailwind CSS, SCSS, and HTML5</b>. I'm passionate about writing <b>clean, maintainable code</b> and implementing <b>best practices</b> in UI/UX development. Always eager to learn new technologies and stay current with the <b>rapidly evolving frontend ecosystem</b>.
                  </div>
                </>
              }
            />

            {/* <About /> */}
            <NewAbout />
          </Container>
        </div>
        <div className=" py-5">
          <Container>
            <SectionHeader
              id="Experience"
              title="Professional Experience"
              detail="Explore my career journey and the expertise I’ve gained along the way."
            />

            <Experience />
          </Container>
        </div>
        <div className="projects-main green-bg py-5">
          <Container>
            <SectionHeader
              id="Projects"
              title="Featured Projects"
              detail="Dive into my work and see how I bring ideas to life through innovation."
            />
            <Project />
          </Container>
        </div>
        <div className="position-relative skill-inner-one py-5">
          <Container>
            <SectionHeader
              id="Skills"
              title="Core Skills"
              detail="Harnessing a diverse set of skills to create remarkable digital solutions."
            />
          </Container>
          <Skills />
        </div>
        <div className="green-bg py-5">
          <Container>
            <SectionHeader
              id="Testimonial"
              title="Testimonials"
              detail="Read what my collaborators say about their experiences working with me."
            />
            <Testimonial />
          </Container>
          
        </div>

        <Footer />
      </div>
      <Suspense fallback={<div />}>
        <ChatbotMain />
      </Suspense>
    </>
  );
}

export default App;
